<organism-cards-list
    [cardType]="cardType"
    [searchType]="searchType | translateTokenisedString"
    [searchTypePlural]="searchTypePlural | translateTokenisedString"
    [searchPlaceholder]="searchPlaceholder | translateTokenisedString"
    [caseCards]="
        cases
            | fn
                : casesAsCaseCardItems
                : isSuggestedCardList
                : linkToEntityType
                : linkToEntityId
                : limit
                : entityRouteService
    "
    [isLoading]="isLoading"
    [hasError]="hasError"
    [totalRecordCount]="totalRecordCount"
    [cardsPerRow]="casesPerRow"
    [filterHandler]="filterHandler"
    [filtersModalId]="filtersModalId"
    [formFilterName]="CASE_FILTER_FORM"
    [sortMenu]="SORT_MENU_CASES"
    [useSortToggleMenu]="true"
    [showFilters]="showFilters"
    [showFilterBar]="showFilterBar"
    [showSearchBar]="showSearchBar"
    [showFavourite]="showFavourite"
    [showLegend]="showLegend"
    [showNoDataSVG]="showNoDataSVG"
    [noDataSVGSize]="noDataSVGSize"
    [noDataMessage]="noDataMessage"
    [hasFilterSearch]="hasFilterSearch"
    [isSuggestedCardList]="isSuggestedCardList"
    [limit]="limit"
    [scrollMode]="scrollMode"
    [cySelector]="'cases-list'"
    (searchTriggered)="onSearch($event)"
    (infinityScrollFired)="onInfinityScrollFired()"
    (toggleFavourite)="onToggleFavourite($event)"
    (refreshCases)="onRefreshCases()"
>
    <ng-content prefixActionButtons select="[prefixActionButtons]"></ng-content>
    @if (caseTypesActionButton) {
        <div class="organism-cards-list-action-button d-flex">
            <molecule-action-button
                size="md"
                class="ms-2"
                btnClass="btn-primary"
                [actionButton]="caseTypesActionButton"
            ></molecule-action-button>
        </div>
    }
</organism-cards-list>
